import { Link } from "react-router-dom";
import { Page, H1, H2, Lead, P, UL, Notice, Toc, DocVersion } from "../../public/primitives";
import { legal } from "../../../config/legal";

// « À finaliser avant activation commerciale » — aucune règle tarifaire future n'est inventée.
const TBD = () => (
  <span data-testid="commercial-tbd" className="text-amber-600 italic font-medium">
    À finaliser avant activation commerciale
  </span>
);

export const CommercialTermsPage = () => (
  <Page testid="commercial-terms-page">
    <H1>Conditions commerciales</H1>
    <Lead>
      Structure des conditions commerciales de SecurePass. Version <DocVersion value={legal.commercialTermsVersion} />.
      Les règles définitives seront arrêtées avant l'activation du paiement.
    </Lead>

    <Toc
      items={[
        { id: "offres", label: "Offres" },
        { id: "prix", label: "Prix" },
        { id: "utilisateurs-supplementaires", label: "Utilisateurs supplémentaires" },
        { id: "facturation", label: "Facturation" },
        { id: "renouvellement", label: "Renouvellement" },
        { id: "changement", label: "Changement d'offre" },
        { id: "resiliation", label: "Résiliation" },
        { id: "paiement", label: "Paiement" },
        { id: "taxes", label: "Taxes" },
        { id: "factures", label: "Factures" },
        { id: "enterprise", label: "Enterprise / sur devis" },
      ]}
    />

    <H2 id="offres">Offres</H2>
    <P>
      SecurePass propose plusieurs offres (voir la page
      <Link to="/offres" className="text-emerald-600 underline"> Offres</Link>). Les conditions
      détaillées par offre : <TBD />.
    </P>

    <H2 id="prix">Prix</H2>
    <P>Modalités et conditions tarifaires définitives : <TBD />.</P>

    <H2 id="utilisateurs-supplementaires">Utilisateurs supplémentaires</H2>
    <P>Règles de facturation des utilisateurs supplémentaires : <TBD />.</P>

    <H2 id="facturation">Facturation</H2>
    <P>Cycle et modalités de facturation : <TBD />.</P>

    <H2 id="renouvellement">Renouvellement</H2>
    <P>Conditions de renouvellement des abonnements : <TBD />.</P>

    <H2 id="changement">Changement d'offre</H2>
    <P>Modalités de passage d'une offre à une autre : <TBD />.</P>

    <H2 id="resiliation">Résiliation</H2>
    <P>Conditions et effets de la résiliation : <TBD />.</P>

    <H2 id="paiement">Paiement</H2>
    <P>Moyens et modalités de paiement : <TBD />.</P>

    <H2 id="taxes">Taxes</H2>
    <P>Traitement des taxes applicables : <TBD />.</P>

    <H2 id="factures">Factures</H2>
    <P>Émission et mise à disposition des factures : <TBD />.</P>

    <H2 id="enterprise">Offres Enterprise / sur devis</H2>
    <P>Conditions des offres sur devis : <TBD />.</P>

    <Notice testid="commercial-work-note">
      Cette page prépare la structure ; les règles commerciales ne sont pas encore définies et ne
      seront pas inventées. Le paiement n'est pas activé.
    </Notice>
  </Page>
);

export default CommercialTermsPage;
